import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { TransportDropdownService } from 'service/dropdownServices/TransportDropdown';

/**
 * Справочник «Вид транспортного средства» (полуприцеп / сцепка / грузовик) как
 * словарь `id → название`: списки транспорта приходят с бэкенда только с
 * `transport_bodytype_additionals_id`, а в таблице нужно показать название.
 */
export const useTransportKinds = (): Record<string, string> => {
    const lang = useSelector((state: any) => state.settings.lang);
    const [kinds, setKinds] = useState<Record<string, string>>({});

    useEffect(() => {
        let isActual = true;
        TransportDropdownService.getBodyTypesAdditional(lang)
            .then((res: any) => {
                if (!isActual) return;
                const dictionary: Record<string, string> = {};
                (res.data || []).forEach((item: any) => {
                    dictionary[item.id] = item.value;
                });
                setKinds(dictionary);
            })
            .catch((e: any) => {
                console.log(e.response);
            });
        return () => {
            isActual = false;
        };
    }, [lang]);

    return kinds;
};
